import { EDocumentSearchField } from 'types/document';
import type { IDocumentsListProps, ISearchFields } from './types';

export const getDocumentSearchFields = (props: IDocumentsListProps): ISearchFields => {
  const { tripId, cargoId, orderId, clientId, invoiceId, whTaskId, expenseId } = props;

  if (tripId) {
    return { field: EDocumentSearchField.tripId, entityId: tripId };
  }
  if (cargoId) {
    return { field: EDocumentSearchField.cargoId, entityId: cargoId };
  }
  if (orderId) {
    return { field: EDocumentSearchField.orderId, entityId: orderId };
  }
  if (clientId) {
    return { field: EDocumentSearchField.clientId, entityId: clientId };
  }
  if (invoiceId) {
    return { field: EDocumentSearchField.invoiceId, entityId: invoiceId };
  }
  if (whTaskId) {
    return { field: EDocumentSearchField.warehouseTaskId, entityId: whTaskId };
  }
  if (expenseId) {
    return { field: EDocumentSearchField.expenseId, entityId: expenseId };
  }

  throw new Error('No valid search field provided');
};
